<template>
    <div class="heroesLeaderboard">
        <el-scrollbar class="course-ware-list">
            <router-view></router-view>
        </el-scrollbar>

    </div>
</template>
<script>
export default {
    data() {
        return {

        };
    },
    methods: {
    },
    mounted() {

    },
};
</script>
<style lang="scss" scoped>
.heroesLeaderboard {
    width: 100%;
    height: 100%;
    background: #eff3fd;
    height: calc(100vh - 112px);
    // overflow-y: auto;
    padding: 20px;
    box-sizing: border-box;

    .course-ware-list {
    
        width: 100%;
        height: 100%;
        background-color: #fff;
        overflow: hidden;

        ::v-deep .el-scrollbar__wrap {
            overflow-x: hidden;
        }
    }

}

::v-deep .el-scrollbar__wrap {
    margin: 0 !important;

    &::-webkit-scrollbar {
        display: none;
    }
}
</style>